module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-19.3b3e813e.png";